var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardDriveOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8029 5.14364C18.7429 4.8223 18.5723 4.53207 18.3209 4.32321C18.0694 4.11435 17.7528 4.00001 17.4259 4H6.57387C6.24697 4.00001 5.93037 4.11435 5.67889 4.32321C5.42741 4.53207 5.2569 4.8223 5.19687 5.14364L3 16.8973H20.9998L18.8029 5.14364Z",
    fill: "#F0A800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9395 15.8359H4.06047C3.47479 15.8359 3 16.3107 3 16.8964V19.5123C3 20.0979 3.47479 20.5727 4.06047 20.5727H19.9395C20.5252 20.5727 21 20.0979 21 19.5123V16.8964C21 16.3107 20.5252 15.8359 19.9395 15.8359Z",
    fill: "#FF961B",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9578 19.2969H8.04248C7.93059 19.2969 7.82329 19.2524 7.74417 19.1733C7.66505 19.0942 7.62061 18.9869 7.62061 18.875C7.62061 18.7631 7.66505 18.6558 7.74417 18.5767C7.82329 18.4976 7.93059 18.4531 8.04248 18.4531H15.9578C16.0697 18.4531 16.177 18.4976 16.2561 18.5767C16.3352 18.6558 16.3797 18.7631 16.3797 18.875C16.3797 18.9869 16.3352 19.0942 16.2561 19.1733C16.177 19.2524 16.0697 19.2969 15.9578 19.2969Z",
    fill: "#FAFCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52103 17.8437H4.73755C4.62566 17.8437 4.51835 17.7993 4.43924 17.7202C4.36012 17.6411 4.31567 17.5338 4.31567 17.4219C4.31567 17.31 4.36012 17.2027 4.43924 17.1236C4.51835 17.0444 4.62566 17 4.73755 17H5.52103C5.63291 17 5.74022 17.0444 5.81934 17.1236C5.89845 17.2027 5.9429 17.31 5.9429 17.4219C5.9429 17.5338 5.89845 17.6411 5.81934 17.7202C5.74022 17.7993 5.63291 17.8437 5.52103 17.8437Z",
    fill: "#36CA8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87137 17.8437H7.08789C6.976 17.8437 6.8687 17.7993 6.78958 17.7202C6.71046 17.6411 6.66602 17.5338 6.66602 17.4219C6.66602 17.31 6.71046 17.2027 6.78958 17.1236C6.8687 17.0444 6.976 17 7.08789 17H7.87137C7.98326 17 8.09056 17.0444 8.16968 17.1236C8.24879 17.2027 8.29324 17.31 8.29324 17.4219C8.29324 17.5338 8.24879 17.6411 8.16968 17.7202C8.09056 17.7993 7.98326 17.8437 7.87137 17.8437Z",
    fill: "#36CA8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDriveOrange);
export default __webpack_public_path__ + "static/media/hard-drive-orange.f1590294f40636cf1fc5a74cfae978d0.svg";
export { ForwardRef as ReactComponent };